import ServiceCard from "./ServiceCard";
import { useSiteContent } from "../../../context/SiteContentContext";

export default function HeatingSection() {
  const { content } = useSiteContent();
  const services = content.services_heating;
  return (
    <section id="heating" className="w-full relative overflow-hidden">
      {/* Full-bleed image header */}
      <div className="w-full relative overflow-hidden" style={{ height: "280px" }}>
        <img
          src="https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=1600&h=560&fit=crop&q=85"
          alt="Heating Systems"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0" style={{ background: "linear-gradient(to bottom,rgba(247,251,255,0) 0%,rgba(247,251,255,0.2) 50%,rgba(247,251,255,1) 100%)" }} />
        <div className="absolute inset-0" style={{ background: "linear-gradient(105deg,rgba(13,40,80,0.55) 0%,transparent 60%)" }} />
        <div className="absolute bottom-8 left-8 md:left-16">
          <div
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest mb-3"
            style={{ background: "rgba(74,159,212,0.3)", color: "#fff", border: "1px solid rgba(74,159,212,0.5)", backdropFilter: "blur(8px)" }}
          >
            <i className="ri-fire-line"></i>
            Our Services
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-white leading-tight">
            Heating <span style={{ color: "#7dd3fc" }}>Systems</span>
          </h2>
        </div>
      </div>

      {/* Cards area */}
      <div className="w-full" style={{ background: "#fff" }}>
        <div className="max-w-6xl mx-auto px-8 py-16 pt-16">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between mb-10 gap-4">
            <p className="text-gray-500 max-w-lg text-sm leading-relaxed">
              Reliable, high-efficiency heating solutions for NYC homes and commercial buildings — built to last through every winter.
            </p>
            <a
              href="#easy"
              onClick={(e) => { e.preventDefault(); document.querySelector("#easy")?.scrollIntoView({ behavior: "smooth" }); }}
              className="flex items-center gap-2 text-sm font-bold whitespace-nowrap cursor-pointer transition-all hover:gap-3"
              style={{ color: "#4a9fd4" }}
            >
              Get a quote <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
            {services.map((s) => (
              <ServiceCard key={s.title} {...s} variant="light" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
